import { queryEndpoint } from '@/utils/queryEndpoint';

export const postData =
  (endpoint: string) => (payload?: Record<string, unknown>) =>
    queryEndpoint(endpoint, { method: 'POST', payload });
